import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { ChatLibraryService } from '../../services/chat-library.service';

const MAX_VISIBLE_LOGOS = 3;

@Component({
  selector: 'app-anchor-chip',
  standalone: true,
  imports: [NgClass, NgFor, NgIf],
  templateUrl: './anchor-chip.component.html',
  styleUrl: './anchor-chip.component.scss',
})
export class AnchorChipComponent {
  @Input({ required: true }) groupId!: string;

  @Input() creativeCount: number = 0;

  @Input() brandLogos: string[] = [];

  @Input() isActive: boolean = false;

  @Input() loading: boolean = false;

  @Output() chipClicked = new EventEmitter<string>();

  private readonly chatLibraryService = inject(ChatLibraryService);

  get visibleLogos(): string[] {
    return this.brandLogos.slice(0, MAX_VISIBLE_LOGOS);
  }

  get hiddenLogoCount(): number {
    return Math.max(this.brandLogos.length - MAX_VISIBLE_LOGOS, 0);
  }

  onClick(): void {
    if (this.loading) return;
    this.chatLibraryService.setActiveGroup(this.groupId);
    this.chatLibraryService.openPanel();
    this.chatLibraryService.scrollToGroup(this.groupId);
    this.chipClicked.emit(this.groupId);
  }
}
